module.exports = __webpack_public_path__ + "media/images/v2/logo-white-d2cdd3be6b6670ccc9afec3597a57b7f.png";